import defaults from "lodash/defaults";

import moment from "moment";

import { DATE_FORMATS } from "../../../constants";

const { UTC } = DATE_FORMATS;

const defaultQueryDateController = (app) => {
  app.get("/*", ({ req }, next) => {
    const { query } = req;
    defaults(query, {
      date: parseInt(moment().format(UTC)),
    });
    return next();
  });
};

export default defaultQueryDateController;
